import React from 'react'
import { UserSwitchOutlined, LoginOutlined, UsergroupAddOutlined, ProductOutlined, SecurityScanOutlined, GlobalOutlined } from '@ant-design/icons'
import { Layout, Menu, theme } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom'
import { clearSession } from '../../api'

const { Header, Content, Footer, Sider } = Layout

export default props => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken()

  const navigate = useNavigate()
  const location = useLocation()

  const languageItems = [
    { key: 'de_DE', label: i18n('language.german'), onClick: () => i18n.changeLanguage('de_DE') },
    { key: 'en_US', label: i18n('language.english'), onClick: () => i18n.changeLanguage('en_US') },
  ]

  return (
    <Layout style={{ height: '100%', minHeight: '100vh' }}>
      <Sider breakpoint="lg" collapsedWidth="0" width={256}>
        <div style={{ height: '100%' }}>
          <div
            style={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              boxSizing: 'border-box',
              paddingBottom: 8,
              justifyContent: 'space-between',
            }}
          >
            <div>
              <div className="logo" style={{ marginBottom: 16 }}>
                <img src="/logo_white.svg" style={{ width: '80%', marginLeft: '10%', marginTop: 32 }} />
              </div>
              <p
                style={{
                  marginBottom: 8,
                  width: '100%',
                  boxSizing: 'border-box',
                  paddingLeft: 32,
                  marginTop: 24,
                  paddingBottom: 4,
                  color: 'rgba(255, 255, 255, 0.5)',
                  borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                }}
              >
                {i18n('nav.features')}
              </p>
              <Menu
                theme="dark"
                mode="inline"
                defaultSelectedKeys={[location.pathname.substring(1)]}
                items={[
                  {
                    key: 'services',
                    icon: <UserSwitchOutlined />,
                    label: i18n('nav.serviceRequests'),
                  },
                  {
                    key: 'verification',
                    icon: <SecurityScanOutlined />,
                    label: i18n('nav.verification'),
                  },
                ]}
                onClick={data => {
                  navigate(`/${data.key}`)
                }}
              />
              <p
                style={{
                  marginBottom: 8,
                  width: '100%',
                  boxSizing: 'border-box',
                  paddingLeft: 32,
                  marginTop: 24,
                  paddingBottom: 4,
                  color: 'rgba(255, 255, 255, 0.5)',
                  borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                }}
              >
                {i18n('nav.administration')}
              </p>
              <Menu
                theme="dark"
                mode="inline"
                defaultSelectedKeys={[location.pathname.substring(1)]}
                items={[
                  {
                    key: 'articles',
                    icon: <ProductOutlined />,
                    label: i18n('nav.manageArticles'),
                  },
                  {
                    key: 'users',
                    icon: <UsergroupAddOutlined />,
                    label: i18n('nav.manageUsers'),
                  },
                ]}
                onClick={data => {
                  navigate(`/${data.key}`)
                }}
              />
            </div>
            <div>
              <div
                className="user"
                style={{
                  userSelect: 'none',
                  boxSizing: 'border-box',
                  color: 'white',
                  padding: '0 32px',
                  borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                  paddingBottom: 24,
                  marginBottom: 16,
                }}
              >
                <div style={{ fontSize: 18 }}>{global.WatchStorage.session.username}</div>
                <div style={{ opacity: 0.5 }}>{global.WatchStorage.session.email}</div>
              </div>
              <Menu
                theme="dark"
                mode="inline"
                selectable={false}
                items={[
                  {
                    key: 'language',
                    icon: <GlobalOutlined />,
                    label: i18n('language.change'),
                    children: languageItems,
                  },
                  {
                    key: 'logout',
                    icon: <LoginOutlined />,
                    label: i18n('common.logout'),
                    // HOR-21: Nicht mehr selbst am Cookie herumraeumen - clearSession()
                    // ist die einzige Stelle, die alle Domain-/Path-Varianten kennt
                    // und das Ergebnis auch prueft. Erst danach redirecten, sonst
                    // laedt die Login-Seite die noch bestehende Session neu ein.
                    onClick: () => {
                      clearSession()
                      window.location.replace('/login')
                    },
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </Sider>
      <Layout>
        <Header
          style={{
            fontSize: 20,
            fontWeight: 400,
            userSelect: 'none',
            padding: 0,
            paddingLeft: 24,
            paddingRight: 24,
            background: colorBgContainer,
          }}
        >
          <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {props.title}
            {props.rightContent}
          </div>
        </Header>
        <Content style={{ margin: '24px' }}>
          <div
            style={
              props.noBackground
                ? {}
                : {
                    padding: 24,
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                  }
            }
          >
            {props.children}
          </div>
        </Content>
        <Footer style={{ textAlign: 'center' }}>{i18n('footer', { year: new Date().getFullYear() })}</Footer>
      </Layout>
    </Layout>
  )
}
